<template>
	<sf-header-layout>
		<template v-slot:front>
			<sf-side-menu-btn v-if="menuData.useSideMenuYN === 'Y'" :onClick="toggleSideMenu" />
			<!-- 로고 클릭시 home으로 이동 -->
			<sf-logo :onClick="() => $router.push(homeUrl).catch(() => {})" :class="{ home: menuData.useSideMenuYN !== 'Y' }" />
		</template>
		<template v-slot:middle>
			<sf-top-menu
				v-if="menuData.useTopMenuYN === 'Y'"
				:menu="menu"
				:withSideMenu="menuData.useSideMenuYN === 'Y'"
				@menuClick="onClickTopMenu"
			/>
		</template>
		<template v-slot:end>
			<header-end
				:menuType="menuType"
				:userName="userName"
				:toggleUserSide="toggleUserSide"
				:useSitemap="useSitemap"
				@sitemapClick="sitemapClick"
				@openScreen="openScreen"
			/>
		</template>
	</sf-header-layout>
</template>

<script>
//상단 헤더 Component
import { rootComputed, rootMethods } from '@/store/common/helpers';
import HeaderEnd from './HeaderEnd';
export default {
	components: { HeaderEnd },
	props: {
		//사용자 이름
		userName: {
			type: String,
			default: ''
		},

		//메뉴 리스트
		menu: {
			type: Array,
			default: () => {}
		},

		//헤더가 존재하는 Layout의 타입
		menuType: {
			type: String,
			default: ''
		},

		//사이트맵 사용 여부
		useSitemap: {
			type: Boolean,
			default: false
		},

		sitemapItem: null //사이트맵 화면 정보
	},

	computed: {
		...rootComputed,

		menuData() {
			return this.getMenu_({ type: this.menuType });
		}
	},

	methods: {
		...rootMethods,

		//좌측 메뉴 토클 버큰 클릭 매서드
		toggleSideMenu() {
			this.$emit('toggleSideMenu'); //좌측 메뉴 토클 버큰 클릭  호출
		},

		//사용자 설정 사이드 바 토클 매서드
		toggleUserSide() {
			this.$emit('toggleUserSide'); //상단 메뉴 클릭 이벤트 호출
		},

		//상단 메뉴에서 메뉴 클릭시
		onClickTopMenu({ item }) {
			this.$emit('clickedMenu', { item }); //상단 메뉴 클릭 이벤트 호출
		},

		//헤더의 사이트 맵 클릭시
		sitemapClick() {
			this.$emit('sitemapClick'); //사이트맵 메뉴 클릭 이벤트 호출
		},

		//즐겨찾기 화면 열기
		openScreen({ item }) {
			this.$emit('openScreen', { item }); //화면 오픈 이벤트 호출
		}
	}
};
</script>

<style></style>
